<div class="oqs-top-panel">
  <a ng-href="{{oqsTopPanel.logoLink}}" target="_blank">
    <div class="oqs-logo">
    </div>
  </a>

  <div ng-if="oqsTopPanel.brokerLogoUrl" class="oqs-broker-branding-logo"
       ng-style="{ 'background-image': 'url(' + oqsTopPanel.brokerLogoUrl + ')' }">
  </div>

  <div class="oqs-title"
       ng-dblclick="oqsTopPanel.showDebug = !oqsTopPanel.showDebug">
    <h1>
      <span oqs-message="{{oqsTopPanel.titleMessageKey}}"></span>
      <ng-transclude/>
    </h1>
  </div>

</div>
<div class="ng-animate oqs-dev-mode oqs-animate-slide"
     ng-if="oqsTopPanel.showDebug && oqsTopPanel.isDevMode()">
  <h5>DevMode Options</h5>
  <button class="btn btn-primary btn-sm" ng-click="oqsTopPanel.clearCache()">Clear Cache</button>
  <div class="checkbox">
    <label><input type="checkbox" value="" ng-model="oqsTopPanel.data.useCustomCss">Use custom.css</label>
  </div>
</div>
